import { get } from 'lodash';

function isCaseOON(serviceCase) {
  return get(serviceCase, 'state') === 'off_platform';
}

export default isCaseOON;
